import React from "react";
import { Helmet } from "react-helmet-async";
import { FaCopy } from "react-icons/fa";
import { toast } from "react-toastify";

const CopyLinkComponent = ({ currentURL, data }) => {
  return (
    <>
      <Helmet>
        <title>{data?.title}</title>
        <meta name="description" content={data?.description} />
        <meta property="og:url" content={currentURL} />
        <meta property="og:title" content={data?.title} />
        <meta property="og:description" content={data?.description} />
        <meta property="og:image" content="https://kwad.in/hightable/img/hightableog.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={data?.title} />
        <meta name="twitter:description" content={data?.description} />
        <meta name="twitter:image" content="https://kwad.in/hightable/img/hightableog.jpg" />
      </Helmet>

      <div>
        <p className="text-gray-600 mb-2">Or copy link</p>
        <div className="flex items-center border border-[#bd9649] rounded-lg overflow-hidden">
          <input
            type="text"
            value={currentURL}
            readOnly
            className="flex-grow px-4 py-3 text-xs md:text-base text-gray-800 bg-gray-50 border-none focus:outline-none"
          />
          <button
            onClick={() => {navigator.clipboard.writeText(currentURL)
              toast.success("Successfully copied to clipboard!!", {
                            position: "top-center",
                          });
            }}
            className="bg-[#e2b760] px-4 py-4 hover:bg-[#bd9649] transition"
          >
            <FaCopy className="text-gray-50 text-lg" />
          </button>
        </div>
      </div>
    </>
  );
};

export default CopyLinkComponent;
